import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API } from '../config';
import { getAuthenticationHeaders } from '../modules/fetch';

export const reviewTicketApi = createApi({
  reducerPath: 'reviewTicketApi',
  baseQuery: fetchBaseQuery({ baseUrl: API }),
  tagTypes: ['ReviewTicket'],
  endpoints: (builder) => ({
    getReviewTicketListing: builder.query({
      query: (customerId) => ({
        url: `/review-tickets/customers/${customerId}/listings/1,100`,
        method: 'GET',
        headers: getAuthenticationHeaders('application/json'),
      }),
      keepUnusedDataFor: 300,
      providesTags: ['ReviewTicket'],
    }),
    getReviewTicketReportTemplate: builder.query({
      query: (id) => ({
        url: `/review-tickets/report-template/${id}`,
        method: 'GET',
        headers: getAuthenticationHeaders('application/json'),
      }),
      keepUnusedDataFor: 300,
      providesTags: ['ReviewTicket'],
    }),
    getReviewTicketDetail: builder.query({
      query: (id) => ({
        url: `/review-tickets/${id}`,
        method: 'GET',
        headers: getAuthenticationHeaders('application/json'),
      }),
      keepUnusedDataFor: 300,
      providesTags: ['ReviewTicket'],
    }),
    addReviewTicketReport: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: `/review-tickets/${id}`,
        method: 'POST',
        headers: getAuthenticationHeaders('application/json'),
        body: rest,
      }),
      invalidatesTags: ['ReviewTicket'],
    }),
  }),
});

export const {
  useGetReviewTicketListingQuery,
  useGetReviewTicketReportTemplateQuery,
  useAddReviewTicketReportMutation,
  useGetReviewTicketDetailQuery,
} = reviewTicketApi;
